import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsVerizonComponent } from './simple-icons-verizon.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsVerizonComponent ],
    exports:      [ SimpleIconsVerizonComponent ],
    bootstrap:    []
})
export class SimpleIconsVerizonModule {}
